import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitQuote = (payload) => client.post("/quote", payload).then((r) => r.data);
export const submitConsultation = (payload) =>
  client.post("/consultation", payload).then((r) => r.data);
export const submitContact = (payload) => client.post("/contact", payload).then((r) => r.data);

export default client;
